/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_Alltime_ZeroInputs */



/**
* | output |
* | --- |
* | "Nothing is owed. All {count} uninvoiced periods price to €0.00 — free periods, not a fault." |
*
* @param {Partner_Billing_Board_Alltime_ZeroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_alltime_zero = /** @type {((inputs: Partner_Billing_Board_Alltime_ZeroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Alltime_ZeroInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Keine Forderung. Alle ${i?.count} nicht fakturierten Zeiträume ergeben 0,00 € — kostenlose Zeiträume, kein Fehler.`)
	return /** @type {LocalizedString} */ (`Nothing is owed. All ${i?.count} uninvoiced periods price to €0.00 — free periods, not a fault.`)
});